module.exports = __webpack_public_path__ + "static/media/vstraivaemyi_termostat.9de7e02b.pdf";